import React from 'react'
import { Provider } from 'react-redux'
import {BrowserRouter as Router} from 'react-router-dom'
import { Grid } from 'react-flexbox-grid';
import ScrollToTop from './components/static/scroll-to-top'
import { ThemeProvider } from 'styled-components'
import theme from './theme'
import store from './state/store'
import Body from './body'



//-- Provider passes our redux store state to components
//-- Router must not be outside StyleRoot
//-- Router must have a single child
//-- Grid is for react-flexbox
//-- ThemeProvider from Styled Components

const App = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Router>
        <ScrollToTop>
          <Grid fluid style={{padding: 0, margin: 0}}>
            <Body />
          </Grid>
        </ScrollToTop>
      </Router>
    </ThemeProvider>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js